'use client';

import { useEffect } from 'react';

/**
 * Google Analytics 4 mit CCM19 Consent-Koppelung
 * Lädt GA4 NUR wenn User Statistik-Cookies zugestimmt hat
 */
export function GoogleAnalytics() {
  useEffect(() => {
    // Google Analytics Property ID
    const GA_MEASUREMENT_ID = 'G-89P6GFRQF1';

    // Google Analytics Opt-out Funktion global verfügbar machen
    if (typeof window !== 'undefined') {
      const disableStr = 'ga-disable-' + GA_MEASUREMENT_ID;

      // Prüfe ob User bereits opted-out hat
      if (document.cookie.indexOf(disableStr + '=true') > -1) {
        window[disableStr] = true;
        console.log('GA4: User hat opted-out');
      }

      // Globale gaOptout Funktion für Datenschutz-Seite
      window.gaOptout = function() {
        document.cookie = disableStr + '=true; expires=Thu, 31 Dec 2099 23:59:59 UTC; path=/';
        window[disableStr] = true;
        alert('Das Tracking durch Google Analytics wurde in Ihrem Browser für diese Website deaktiviert.');
        console.log('GA4: Tracking deaktiviert via gaOptout()');
      };
    }

    // Warte auf CCM19 Consent-Entscheidung
    const checkConsent = () => {
      // CCM19 speichert Consent-Entscheidungen in window.CCM
      if (typeof window !== 'undefined' && window.CCM) {
        // Prüfe ob Google Analytics in den akzeptierten Embeddings ist
        // CCM19 speichert akzeptierte Tools als Array von Objekten
        const consentGiven = window.CCM.acceptedEmbeddings &&
                           window.CCM.acceptedEmbeddings.length > 0 &&
                           window.CCM.acceptedEmbeddings.some(tool =>
                             tool.name && (
                               tool.name.toLowerCase().includes('google analytics') ||
                               tool.name.toLowerCase().includes('analytics')
                             )
                           );

        if (consentGiven) {
          initGA4();
        }
      }
    };

    // Event-Listener für CCM19 Consent-Änderungen
    const handleConsentChange = () => {
      checkConsent();
    };

    // Warte bis CCM19 geladen ist
    const waitForCCM = setInterval(() => {
      if (window.CCM) {
        clearInterval(waitForCCM);
        checkConsent();
      }
    }, 100);

    // Höre auf Consent-Änderungen
    document.addEventListener('ccm19WidgetClosed', handleConsentChange);

    // Cleanup
    return () => {
      clearInterval(waitForCCM);
      document.removeEventListener('ccm19WidgetClosed', handleConsentChange);
    };
  }, []);

  const initGA4 = () => {
    // Initialisiere GA4 nur wenn noch nicht geladen
    if (window.dataLayer) {
      console.log('GA4 bereits geladen');
      return;
    }

    // Google Analytics 4 Setup
    window.dataLayer = window.dataLayer || [];
    function gtag() {
      window.dataLayer.push(arguments);
    }
    window.gtag = gtag;

    gtag('js', new Date());
    gtag('config', 'G-89P6GFRQF1');

    // Lade gtag.js Script
    const script = document.createElement('script');
    script.async = true;
    script.src = 'https://www.googletagmanager.com/gtag/js?id=G-89P6GFRQF1';
    document.head.appendChild(script);

    console.log('GA4 initialisiert');
  };

  // Kein Script-Tag rendern, da wir dynamisch laden
  return null;
}

export default GoogleAnalytics;
